import isEqual from 'react-fast-compare';
import {useSelector} from 'react-redux';

export default function useUser() {
    return useSelector(({user}) => user, isEqual);
}
